<app-regulatory-tabs></app-regulatory-tabs>
